import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchProjectInvitees } from 'api/invitee.service';
import { InviteeModel } from 'types/entity/invitee-model';

export const PROJECT_INVITEE_READ_STORE_NAME = 'projectInviteeRead';

export const loadProjectInvitees = createAsyncThunk(
  `${PROJECT_INVITEE_READ_STORE_NAME}/load`,
  async (selectedProjectId: string) => {
    const response = await fetchProjectInvitees(selectedProjectId);
    return response;
  },
);

export type ProjectInviteeReadState = {
    loaded: boolean
    entity: InviteeModel[] | undefined
    error: any
}

export const initialProjectInviteeReadState: ProjectInviteeReadState = {
  entity: [],
  loaded: false,
  error: null,
};

export const projectInviteeReadSlice = createSlice({
  name: PROJECT_INVITEE_READ_STORE_NAME,
  initialState: initialProjectInviteeReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadProjectInvitees.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadProjectInvitees.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadProjectInvitees.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const projectInviteeReadAction = {
  ...projectInviteeReadSlice.actions,
  loadProjectInvitees,
};

export default projectInviteeReadSlice.reducer;
